/* wig-builder.js - Adéorí Custom Wig Builder logic (extracted from sections/wig-builder.liquid) */
// All prices and availability sourced exclusively from Shopify variant data.
// NOTE: BUNDLE_DATA is intentionally NOT cached - always read window.ADEORI_BUNDLE_DATA
// live so the async fetch result is always reflected (const BUNDLE_DATA would capture
// the initial empty {} before the fetch resolves and never see the loaded data).
const CONSTRUCTION_FEE = window.ADEORI_CONSTRUCTION_FEE || 0;
const LACE_DATA   = window.ADEORI_LACE_DATA   || {};
const LENGTHS = [16,18,20,22,24];
// Lace lengths come from the live Shopify variants in LACE_DATA ("size|texture|length").
function laceLengths(size, texture) {
  const out = [];
  Object.keys(LACE_DATA).forEach(k => {
    const p = k.split('|');
    if (p[0] === size && p[1] === texture) out.push(parseInt(p[2], 10));
  });
  return out.length ? out.sort((a, b) => a - b) : [16, 18, 20];
}

function getBundleVariant(texture, length) {
  const bd = window.ADEORI_BUNDLE_DATA || {};
  return (bd[texture] && bd[texture][String(length)]) || null;
}
function getBundlePrice(texture, length) {
  const v = getBundleVariant(texture, length);
  return v ? v.price : 0;
}
function isBundleAvailable(texture, length) {
  const v = getBundleVariant(texture, length);
  if (!v) return true; // No Shopify data yet - show as available, not blocked
  return v.available;  // Only disable when Shopify explicitly marks out of stock
}
function getLaceVariant(size, texture, length) {
  return LACE_DATA[size + '|' + texture + '|' + length] || null;
}
// No-lace base styles (V-part, half wig): wefts on a cap, no closure/frontal product.
function isNoLaceBase(size) { return size === 'v-part' || size === 'half-wig'; }

const state = {
  step: 1,
  texture: null,
  bundleCount: 2,
  bundleLengths: [null, null],
  closureSize: null,
  closureLabel: null,
  closureLength: null,
  closurePrice: 0,
  closureVariantId: null,
  capSize: null,
};

function calcBundlesTotal() {
  return state.bundleLengths.slice(0, state.bundleCount).reduce((s, l) => l !== null ? s + getBundlePrice(state.texture, l) : s, 0);
}
function calcTotal() {
  return calcBundlesTotal() + state.closurePrice + CONSTRUCTION_FEE;
}
function fmt(n) { return n > 0 ? '$' + n.toFixed(0) : '-'; }

function showStepHint(step, msg) {
  var el = document.getElementById('hint-' + step);
  if (!el) return;
  if (msg) el.childNodes[el.childNodes.length - 1].textContent = msg;
  el.classList.add('visible');
}
function clearStepHint(step) {
  var el = document.getElementById('hint-' + step);
  if (el) el.classList.remove('visible');
}

function isStepComplete(step) {
  if (step === 1) return !!state.texture;
  if (step === 2) return state.bundleLengths.slice(0, state.bundleCount).every(l => l !== null);
  if (step === 3) return isNoLaceBase(state.closureSize) ? true : (!!state.closureSize && !!state.closureLength);
  if (step === 4) return !!state.capSize;
  return true;
}
function stepIncompleteMessage(step) {
  if (step === 1) return 'Please select a hair texture before continuing.';
  if (step === 2) return 'Please select a length for each weft before continuing.';
  if (step === 3) return state.closureSize ? 'Please select a length for your lace base before continuing.' : 'Please select a base before continuing.';
  if (step === 4) return 'Please select a cap size before continuing.';
  return '';
}

function goToStep(n) {
  if (n > state.step + 1) return;
  // Validate the current step before allowing forward navigation
  if (n > state.step && !isStepComplete(state.step)) {
    var hintMsg = state.step === 3 && state.closureSize && !state.closureLength
      ? 'Now select a length for your lace base to continue'
      : null;
    showStepHint(state.step, hintMsg);
    // Scroll to length selector if size is picked but length isn't
    if (state.step === 3 && state.closureSize && !state.closureLength) {
      var ls = document.getElementById('closure-length-section');
      if (ls) ls.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    return;
  }
  state.step = n;
  document.querySelectorAll('.step-panel').forEach(p => p.classList.remove('active'));
  document.getElementById('step-' + n).classList.add('active');
  updateProgress();
  if (n === 2) renderBundleRows();
  if (n === 5) renderFinalReview();
  updateSummary();
  // Show/hide the "Start over" button - only relevant from step 2 onwards
  var resetWrap = document.getElementById('progress-reset-wrap');
  if (resetWrap) resetWrap.style.display = n > 1 ? 'flex' : 'none';
  // Hide "How It Works" once building starts; restore if they go back to step 1
  var hiw = document.getElementById('wb-hiw');
  if (hiw) hiw.style.display = n > 1 ? 'none' : '';
  hideClearConfirm();
  setTimeout(() => document.getElementById('wb-progress').scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
}

function showClearConfirm() {
  document.getElementById('progress-reset-btn').style.display = 'none';
  var confirm = document.getElementById('progress-reset-confirm');
  confirm.style.display = 'flex';
}
function hideClearConfirm() {
  var btn = document.getElementById('progress-reset-btn');
  var confirm = document.getElementById('progress-reset-confirm');
  if (btn) btn.style.display = '';
  if (confirm) confirm.style.display = 'none';
}
function executeClearBuild() {
  // Reset all state to initial values
  state.step = 1;
  state.texture = null;
  state.bundleCount = 2;
  state.bundleLengths = [null, null];
  state.closureSize = null;
  state.closureLabel = null;
  state.closureLength = null;
  state.closurePrice = 0;
  state.closureVariantId = null;
  state.capSize = null;

  // Reset add-to-cart button so they can add a new build
  isAdding = false;
  var btn = document.getElementById('main-add-cart');
  if (btn) {
    btn.disabled = false;
    btn.removeAttribute('onclick');
    btn.onclick = addToShopifyCart;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg> Add to Cart <span id="cart-price-btn"></span>';
    btn.style.background = '';
  }
  var mBtn = document.getElementById('mobile-add-cart');
  if (mBtn) {
    mBtn.onclick = addToShopifyCart;
    mBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg><span>Add to Cart</span>';
    mBtn.style.background = '';
  }

  // Clear any cart messages
  var msg = document.getElementById('cart-message');
  if (msg) { msg.textContent = ''; msg.className = 'cart-message'; }

  // Re-show How It Works section
  var hiw = document.getElementById('wb-hiw');
  if (hiw) hiw.style.display = '';

  // Clear texture selection UI
  document.querySelectorAll('.texture-card').forEach(c => c.classList.remove('selected'));

  // Navigate back to step 1 (bypass guard by setting step first)
  state.step = 1;
  document.querySelectorAll('.step-panel').forEach(p => p.classList.remove('active'));
  document.getElementById('step-1').classList.add('active');
  updateProgress();
  updateSummary();

  // Hide the start-over button (back on step 1)
  var resetWrap = document.getElementById('progress-reset-wrap');
  if (resetWrap) resetWrap.style.display = 'none';
}
function nextStep(n) { goToStep(n); }
function goToStep4() { goToStep(4); }
function mobileCtaClick() {
  if (state.step < 5) goToStep(state.step + 1);
  else addToShopifyCart();
}

function updateProgress() {
  document.querySelectorAll('.progress-step').forEach((s, i) => {
    s.classList.remove('active', 'done');
    if (i + 1 < state.step) s.classList.add('done');
    if (i + 1 === state.step) s.classList.add('active');
  });
  document.querySelectorAll('.step-connector').forEach((c, i) => {
    c.classList.toggle('done', i + 1 < state.step);
  });
  document.querySelectorAll('.sticky-dot').forEach((d, i) => {
    d.classList.remove('active', 'done');
    if (i + 1 < state.step) d.classList.add('done');
    if (i + 1 === state.step) d.classList.add('active');
  });
  document.getElementById('mobile-cta-text').textContent = state.step === 5 ? 'Add to Cart' : 'Next Step';
}

// Texture selection: desktop hover swaps to flatlay naturally via CSS.
// Mobile: single tap shows flatlay briefly (300ms) then selects and advances.
function selectTexture(card) {
  const isTouch = window.matchMedia('(hover: none)').matches;
  document.querySelectorAll('.texture-card').forEach(c => c.classList.remove('selected', 'show-flatlay'));
  card.classList.add('show-flatlay');
  if (isTouch) {
    // Brief flatlay reveal on tap, then select and advance
    setTimeout(() => {
      card.classList.add('selected');
      state.texture = card.dataset.texture;
      updateSummary();
      setTimeout(() => nextStep(2), 280);
    }, 320);
  } else {
    card.classList.add('selected');
    state.texture = card.dataset.texture;
    updateSummary();
    setTimeout(() => nextStep(2), 340);
  }
}

function changeBundles(delta) {
  state.bundleCount = Math.max(2, Math.min(5, state.bundleCount + delta));
  document.getElementById('bundle-count').textContent = state.bundleCount;
  while (state.bundleLengths.length < state.bundleCount) state.bundleLengths.push(null);
  const minBtn = document.querySelector('.qty-btn[aria-label="Remove weft"]');
  const maxBtn = document.querySelector('.qty-btn[aria-label="Add weft"]');
  if (minBtn) { minBtn.disabled = state.bundleCount <= 2; minBtn.style.opacity = state.bundleCount <= 2 ? '0.4' : ''; }
  if (maxBtn) { maxBtn.disabled = state.bundleCount >= 5; maxBtn.style.opacity = state.bundleCount >= 5 ? '0.4' : ''; }
  renderBundleRows();
  updateSummary();
}
function renderBundleRows() {
  const container = document.getElementById('bundle-rows');
  container.innerHTML = '';
  for (let i = 0; i < state.bundleCount; i++) {
    const len = state.bundleLengths[i]; // null = no selection yet
    const price = len !== null ? getBundlePrice(state.texture, len) : 0;
    const row = document.createElement('div');
    row.className = 'bundle-row';
    row.innerHTML = `
      <div class="bundle-row-top">
        <span class="bundle-row-label">Weft ${i + 1}</span>
        <span class="bundle-row-price" id="bp-${i}">${len !== null ? fmt(price) : 'Select length'}</span>
      </div>
      <div class="length-btns" id="lb-${i}">
        ${LENGTHS.map(l => {
          const avail = isBundleAvailable(state.texture, l);
          const sel   = len !== null && l === len;
          return avail
            ? `<button class="length-btn${sel ? ' selected' : ''}" onclick="setLength(${i},${l},this)">${l}"</button>`
            : `<button class="length-btn oos" disabled title="Out of stock">${l}"</button>`;
        }).join('')}
      </div>`;
    container.appendChild(row);
  }
}
function setLength(idx, len, btn) {
  state.bundleLengths[idx] = len;
  document.querySelectorAll(`#lb-${idx} .length-btn`).forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  const el = document.getElementById('bp-' + idx);
  if (el) el.textContent = fmt(getBundlePrice(state.texture, len));
  updateSummary();
  // Clear hint once all weft lengths are chosen
  if (state.bundleLengths.slice(0, state.bundleCount).every(l => l !== null)) clearStepHint(2);
}

function selectClosureSize(card, size) {
  document.querySelectorAll('.closure-size-card').forEach(c => c.classList.remove('selected'));
  card.classList.add('selected');
  state.closureSize = size;
  // Reset length when size changes
  state.closureLength = null;
  state.closurePrice = 0;
  state.closureVariantId = null;
  document.querySelectorAll('#closure-length-btns .length-btn').forEach(b => b.classList.remove('selected'));

  if (isNoLaceBase(size)) {
    // V-part / half wig: no lace product, no length to pick - step is complete
    state.closureLabel = card.dataset.label || (size === 'v-part' ? 'V-Part' : 'Half Wig');
    document.getElementById('closure-length-section').style.display = 'none';
    updateSummary();
    clearStepHint(3);
    return;
  }

  state.closureLabel = size + ' ' + (card.dataset.label || 'Closure');
  // Render length buttons with live stock status, then reveal
  renderClosureLengthBtns();
  document.getElementById('closure-length-section').style.display = 'block';
  document.getElementById('closure-length-section').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  updateSummary();
  // Update hint: size chosen, now prompt for length
  showStepHint(3, 'Now select a length for your lace base to continue');
}

function renderClosureLengthBtns() {
  const container = document.getElementById('closure-length-btns');
  if (!container) return;
  const lengths = laceLengths(state.closureSize, state.texture);
  container.innerHTML = lengths.map(l => {
    const v = getLaceVariant(state.closureSize, state.texture, l);
    // If no Shopify data yet, show as available - only hide when explicitly OOS
    const available = !v || v.available;
    return available
      ? `<button class="length-btn" onclick="selectClosureLength(${l},this)">${l}"</button>`
      : `<button class="length-btn oos" disabled title="Out of stock">${l}"</button>`;
  }).join('');
}

function selectClosureLength(len, btn) {
  const v = getLaceVariant(state.closureSize, state.texture, len);
  if (v && !v.available) return; // blocked only when Shopify explicitly says OOS
  state.closureLength    = len;
  state.closurePrice     = v ? v.price : 0;
  state.closureVariantId = v ? v.id   : null;
  document.querySelectorAll('#closure-length-btns .length-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  updateSummary();
  clearStepHint(3);
}

function selectCap(card, size) {
  document.querySelectorAll('.cap-card').forEach(c => c.classList.remove('selected'));
  card.classList.add('selected');
  state.capSize = size;
  updateSummary();
  clearStepHint(4);
}

function renderFinalReview() {
  const total = calcTotal();
  const selectedLengths = state.bundleLengths.slice(0, state.bundleCount).filter(l => l !== null);
  const baseValue = isNoLaceBase(state.closureSize)
    ? state.closureLabel + ' (no lace)'
    : ((state.closureLabel && state.closureLength) ? state.closureLabel + ', ' + state.closureLength + '" ' + fmt(state.closurePrice) : '-');
  const items = [
    ['Texture', state.texture || '-'],
    ['Wefts', selectedLengths.length ? state.bundleCount + ' x ' + selectedLengths.map(l => l + '"').join(', ') : '-'],
    ['Base', baseValue],
    ['Cap Size', state.capSize || '-'],
    ['Construction', '$' + CONSTRUCTION_FEE],
    ['Build Time', '7 to 10 business days'],
  ];
  document.getElementById('final-review').innerHTML =
    items.map(([k, v]) => `<div class="final-item"><div class="final-item-label">${k}</div><div class="final-item-value">${v}</div></div>`).join('') +
    `<div class="final-item total" style="grid-column:1/-1;display:flex;justify-content:space-between;align-items:center">
       <div><div class="final-item-label">Order Total</div><div class="final-item-value">${fmt(total)}</div></div>
       <div style="text-align:right;font-size:.76rem;color:var(--muted)">Free US shipping<br>on orders over $350</div>
     </div>`;
}

function updateSummary() {
  const bundleTotal = calcBundlesTotal();
  const total = calcTotal();
  // hasBundle: true as soon as texture is chosen AND at least one length is picked
  const hasBundle = !!(state.texture && state.bundleLengths.slice(0, state.bundleCount).some(l => l !== null));

  const texEl = document.getElementById('sum-texture');
  texEl.textContent = state.texture || 'Not chosen yet';
  texEl.className = 'summary-value' + (state.texture ? '' : ' empty');

  const bunEl = document.getElementById('sum-bundles');
  if (hasBundle) {
    bunEl.textContent = bundleTotal > 0
      ? state.bundleCount + ' wefts ' + fmt(bundleTotal)
      : state.bundleCount + ' wefts';
    bunEl.className = 'summary-value';
  } else {
    bunEl.textContent = 'Not chosen yet';
    bunEl.className = 'summary-value empty';
  }

  const clEl = document.getElementById('sum-closure');
  if (isNoLaceBase(state.closureSize)) {
    clEl.textContent = state.closureLabel + ', no lace';
    clEl.className = 'summary-value';
  } else if (state.closureLabel && state.closureLength) {
    clEl.textContent = state.closureLabel + ', ' + state.closureLength + '" ' + fmt(state.closurePrice);
    clEl.className = 'summary-value';
  } else if (state.closureLabel) {
    clEl.textContent = state.closureLabel + ', pick a length';
    clEl.className = 'summary-value empty';
  } else {
    clEl.textContent = 'Not chosen yet';
    clEl.className = 'summary-value empty';
  }

  const capEl = document.getElementById('sum-cap');
  capEl.textContent = state.capSize || 'Not chosen yet';
  capEl.className = 'summary-value' + (state.capSize ? '' : ' empty');

  document.getElementById('price-bundles').textContent = hasBundle ? fmt(bundleTotal) : '-';
  document.getElementById('price-closure').textContent = isNoLaceBase(state.closureSize)
    ? 'None' : (state.closurePrice > 0 ? fmt(state.closurePrice) : '-');
  document.getElementById('price-construction').textContent = CONSTRUCTION_FEE > 0 ? fmt(CONSTRUCTION_FEE) : '-';

  const baseChosen = isNoLaceBase(state.closureSize) || (state.closureLabel && state.closureLength);
  const showTotal = hasBundle && baseChosen && state.capSize;
  // Show running total as soon as wefts are chosen - sum whatever is selected so far
  let runningTotal = 0;
  if (hasBundle) { runningTotal += bundleTotal + CONSTRUCTION_FEE; }
  if (state.closurePrice > 0) { runningTotal += state.closurePrice; }
  document.getElementById('price-total').textContent = hasBundle ? fmt(runningTotal) : '-';

  const cartBtn = document.getElementById('cart-price-btn');
  if (cartBtn) cartBtn.textContent = showTotal ? ' ' + fmt(total) : '';

  document.getElementById('mobile-price').textContent = showTotal ? fmt(total) : (hasBundle ? fmt(runningTotal) : 'Configure above');
}

function toggleFaq(question) {
  const item = question.parentElement;
  const wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!wasOpen) item.classList.add('open');
}

let isAdding = false;
async function addToShopifyCart() {
  if (isAdding) return;
  if (!state.texture) {
    goToStep(1);
    showCartMessage('Please select a texture first.', 'error');
    return;
  }
  const unsetLengths = state.bundleLengths.slice(0, state.bundleCount).some(l => l === null);
  if (unsetLengths) {
    goToStep(2);
    showCartMessage('Please select a length for each weft.', 'error');
    return;
  }
  if (!state.closureLabel) {
    goToStep(3);
    showCartMessage('Please choose a base for your wig.', 'error');
    return;
  }
  if (!isNoLaceBase(state.closureSize) && !state.closureLength) {
    goToStep(3);
    showCartMessage('Please choose a length for your lace base.', 'error');
    return;
  }
  if (!state.capSize) {
    goToStep(4);
    showCartMessage('Please select your cap size.', 'error');
    return;
  }

  isAdding = true;
  const btn = document.getElementById('main-add-cart');
  const mBtn = document.getElementById('mobile-cta');
  btn.disabled = true;
  btn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> Building your cart...`;

  const bundleId = 'wb-' + Date.now();
  const items = [];

  for (let i = 0; i < state.bundleCount; i++) {
    const len = state.bundleLengths[i];
    const v = getBundleVariant(state.texture, len);
    if (v && v.id) {
      items.push({ id: v.id, quantity: 1,
        properties: { 'Wig Build': 'Custom ' + state.texture + ' ' + state.capSize + ' cap', 'Weft': (i + 1) + ' of ' + state.bundleCount, '_bundle_id': bundleId }
      });
    }
  }

  const laceVariant = isNoLaceBase(state.closureSize) ? null : getLaceVariant(state.closureSize, state.texture, state.closureLength);
  const laceVariantId = isNoLaceBase(state.closureSize) ? null : (state.closureVariantId || (laceVariant ? laceVariant.id : null));
  if (laceVariantId) {
    items.push({ id: laceVariantId, quantity: 1,
      properties: {
        'For Wig Build': state.texture + ' ' + state.capSize + ' cap',
        'Size': state.closureLabel,
        'Length': state.closureLength + '"',
        '_bundle_id': bundleId
      }
    });
  }

  const baseDesc = isNoLaceBase(state.closureSize)
    ? state.closureLabel + ' (no lace)'
    : state.closureLabel + ', ' + state.closureLength + '"';

  const constructionId = window.ADEORI_CONSTRUCTION_VARIANT_ID;
  if (constructionId) {
    items.push({ id: constructionId, quantity: 1,
      properties: {
        'Texture': state.texture,
        'Wefts': state.bundleCount + ' x (' + state.bundleLengths.slice(0, state.bundleCount).join('", ') + '")',
        'Base': baseDesc,
        'Cap Size': state.capSize,
        'Build Time': '7 to 10 business days',
        '_bundle_id': bundleId
      }
    });
  }

  const cartNote = [
    'Custom Wig Build ' + state.texture,
    'Wefts: ' + state.bundleCount + ' x (' + state.bundleLengths.slice(0, state.bundleCount).join('", ') + '")',
    'Base: ' + baseDesc,
    'Cap Size: ' + state.capSize,
    'Build Time: 7 to 10 business days',
  ].join(' | ');

  try {
    // If editing an existing build, remove the old bundle items first
    const editParams = new URLSearchParams(window.location.search);
    const oldBundleId = editParams.get('edit') === '1' ? editParams.get('bundleId') : null;
    if (oldBundleId) {
      const currentCart = await fetch('/cart.js').then(r => r.json());
      const oldItems = currentCart.items.filter(
        item => item.properties && item.properties['_bundle_id'] === oldBundleId
      );
      if (oldItems.length) {
        const updates = {};
        oldItems.forEach(item => { updates[item.key] = 0; });
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
    }

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: cartNote })
    });

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) throw new Error('Cart add failed');

    // Success - permanently convert button to "View Cart" so customer cannot add the same build twice
    btn.disabled = false;
    btn.removeAttribute('onclick');
    btn.onclick = () => { window.location.href = '/cart'; };
    btn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18"><polyline points="20 6 9 17 4 12"/></svg> View Cart`;
    btn.style.background = 'linear-gradient(135deg,#1A7A6E,#155f56)';
    mBtn.onclick = () => { window.location.href = '/cart'; };
    mBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg><span>View Cart</span>`;
    mBtn.style.background = 'linear-gradient(135deg,#1A7A6E,#155f56)';
    showCartMessage('Your custom wig is in the cart! Proceed to checkout when ready.', 'success');

    // Hide the "How It Works" section - no longer relevant once the build is added
    var hiwSection = document.getElementById('wb-hiw');
    if (hiwSection) hiwSection.style.display = 'none';

    document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
      el.textContent = parseInt(el.textContent || '0') + 1; // one build = one item
    });
    // isAdding stays true - prevents any re-submission attempt

  } catch (err) {
    isAdding = false;
    console.error('Cart error:', err);
    btn.disabled = false;
    btn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg> Add to Cart ${fmt(calcTotal())}`;
    btn.style.background = '';
    showCartMessage('Something went wrong. Please try again or contact us.', 'error');
  }
}

function showCartMessage(msg, type) {
  const el = document.getElementById('cart-message');
  el.textContent = msg;
  el.className = 'cart-message ' + type;
  el.style.display = 'block';
  setTimeout(() => el.style.display = 'none', 6000);
}

renderBundleRows();
updateSummary();

// Pre-fill from URL params - handles both quiz (?texture&length) and cart edit (?edit=1&texture&bundles&closureSize&closureLength&capSize)
(function() {
  var params = new URLSearchParams(window.location.search);
  var presetTexture = params.get('texture');
  if (!presetTexture) return;

  var isEdit         = params.get('edit') === '1';
  var presetBundles  = params.get('bundles');       // "24,22,20"
  var presetClSize   = params.get('closureSize');   // "5x5"
  var presetClLen    = parseInt(params.get('closureLength')) || null; // 20
  var presetCapSize  = params.get('capSize');        // "Medium"
  var presetLength   = parseInt(params.get('length')) || null; // quiz single length

  // Quiz passes the product handle; cart-edit passes the product title. Match either.
  var matchCard = Array.from(document.querySelectorAll('.texture-card'))
    .find(function(c) { return c.dataset.texture === presetTexture || c.dataset.textureHandle === presetTexture; });
  if (!matchCard) return;
  var textureTitle = matchCard.dataset.texture;

  // 1. Pre-select texture card
  document.querySelectorAll('.texture-card').forEach(function(c) { c.classList.remove('selected', 'show-flatlay'); });
  matchCard.classList.add('selected');
  state.texture = textureTitle;

  // 2. Pre-fill weft lengths
  if (isEdit && presetBundles) {
    var lengths = presetBundles.split(',').map(Number).filter(function(n) { return n >= 10 && n <= 26; });
    if (lengths.length >= 2) {
      state.bundleCount = Math.min(5, lengths.length);
      state.bundleLengths = lengths.slice(0, state.bundleCount);
      document.getElementById('bundle-count').textContent = state.bundleCount;
      var minBtn = document.querySelector('.qty-btn[aria-label="Remove weft"]');
      var maxBtn = document.querySelector('.qty-btn[aria-label="Add weft"]');
      if (minBtn) { minBtn.disabled = state.bundleCount <= 2; minBtn.style.opacity = state.bundleCount <= 2 ? '0.4' : '1'; }
      if (maxBtn) { maxBtn.disabled = state.bundleCount >= 5; maxBtn.style.opacity = state.bundleCount >= 5 ? '0.4' : '1'; }
      renderBundleRows();
    }
  } else if (!isEdit && presetLength && presetLength >= 10 && presetLength <= 26) {
    // Quiz prefill: same length for all wefts
    for (var i = 0; i < state.bundleCount; i++) state.bundleLengths[i] = presetLength;
  }

  // 3. Pre-fill base (closure size + length, or no-lace style) (edit only)
  if (isEdit && presetClSize) {
    var clSizeCard = Array.from(document.querySelectorAll('.closure-size-card'))
      .find(function(c) { return c.dataset.size === presetClSize; });
    if (clSizeCard) {
      document.querySelectorAll('.closure-size-card').forEach(function(c) { c.classList.remove('selected'); });
      clSizeCard.classList.add('selected');
      state.closureSize  = presetClSize;
      if (isNoLaceBase(presetClSize)) {
        state.closureLabel = clSizeCard.dataset.label || (presetClSize === 'v-part' ? 'V-Part' : 'Half Wig');
      } else {
        state.closureLabel = presetClSize + ' ' + (clSizeCard.dataset.label || 'Closure');
        renderClosureLengthBtns();
        document.getElementById('closure-length-section').style.display = 'block';
      }
    }
    if (presetClLen && !isNoLaceBase(presetClSize) &&
        laceLengths(state.closureSize, state.texture).indexOf(presetClLen) !== -1) {
      var v = getLaceVariant(state.closureSize, state.texture, presetClLen);
      state.closureLength    = presetClLen;
      state.closurePrice     = v ? v.price : 0;
      state.closureVariantId = v ? v.id   : null;
      // Mark length button selected
      setTimeout(function() {
        document.querySelectorAll('#closure-length-btns .length-btn').forEach(function(b) {
          if (parseInt(b.textContent) === presetClLen) b.classList.add('selected');
        });
      }, 0);
    }
  }

  // 4. Pre-fill cap size (edit only)
  if (isEdit && presetCapSize) {
    var capCard = Array.from(document.querySelectorAll('.cap-card'))
      .find(function(c) {
        var label = c.querySelector('.cap-size-label');
        return label && label.textContent.trim().toLowerCase() === presetCapSize.toLowerCase();
      });
    if (capCard) {
      document.querySelectorAll('.cap-card').forEach(function(c) { c.classList.remove('selected'); });
      capCard.classList.add('selected');
      state.capSize = presetCapSize;
    }
  }

  updateSummary();

  // 5. Navigate to deepest valid step
  if (isEdit) {
    var targetStep = 1;
    if (state.texture) targetStep = 2;
    if (state.bundleLengths.slice(0, state.bundleCount).every(function(l) { return l !== null; })) targetStep = 3;
    if (isNoLaceBase(state.closureSize) || (state.closureSize && state.closureLength)) targetStep = 4;
    if (state.capSize) targetStep = 5;
    // Bypass guard: set step just below target so goToStep allows it
    state.step = targetStep - 1;
    goToStep(targetStep);
  } else {
    // From quiz: texture is pre-selected, so start the build at the wefts step.
    state.step = 1;
    goToStep(2);
  }

  // Land on the builder (past the hero) after a prefill. goToStep's own smooth
  // scroll doesn't stick during initial page load, so re-assert with an instant
  // jump, retried a couple times to beat any load-time scroll reset.
  var scrollToBuilder = function() {
    var prog = document.getElementById('wb-progress');
    if (prog) prog.scrollIntoView({ behavior: 'instant', block: 'start' });
  };
  setTimeout(scrollToBuilder, 300);
  setTimeout(scrollToBuilder, 800);

  // 6. Banner
  var banner = document.getElementById('quiz-prefill-banner');
  var bannerText = document.getElementById('quiz-prefill-text');
  if (banner && bannerText) {
    if (isEdit) {
      var baseNote = '';
      if (presetClSize) {
        baseNote = isNoLaceBase(presetClSize)
          ? ' · ' + (presetClSize === 'v-part' ? 'V-part' : 'half wig') + ' (no lace)'
          : ' · ' + presetClSize + ' closure';
      }
      bannerText.innerHTML = '<strong>✏ Editing your build:</strong> ' + textureTitle
        + (presetBundles ? ' · ' + presetBundles.split(',').length + ' wefts' : '')
        + baseNote
        + '. Change any step above.';
    } else {
      bannerText.innerHTML = '<strong>✔ From your quiz:</strong> ' + textureTitle + ' pre-selected'
        + (presetLength ? ' · ' + presetLength + '″ set for all wefts' : '')
        + '. Change any time.';
    }
    banner.style.display = 'flex';
  }
})();
